export function actionDockSetExpandLeadsStatuses(value) {
    return {
        type: 'DOCK_EXPAND_LEADS_STATUSES',
        value: value
    };
}

export function actionDockSetExpandReports(value) {
    return {
        type: 'DOCK_EXPAND_REPORTS',
        value: value
    };
}

export function actionDockSetExpandLeads(value) {
    return {
        type: 'DOCK_EXPAND_LEADS',
        value: value
    };
}

export function actionDockSetExpandUsers(value) {
    return {
        type: 'DOCK_EXPAND_USERS',
        value: value
    };
}

export function actionDockSetExpandFiles(value) {
    return {
        type: 'DOCK_EXPAND_FILES',
        value: value
    };
}

export function actionDockSetExpandNotes(value) {
    return {
        type: 'DOCK_EXPAND_NOTES',
        value: value
    };
}
